module.exports = __webpack_public_path__ + "img/rcrclc_fwsx.deb31de2.png";